export default __webpack_public_path__ + "static/media/selections.34af953e.svg";